import { stateGo } from 'redux-ui-router';
import { anchorStorage } from 'utils';
import { selectHasWorkoutSubscription, selectMember } from 'logic/member';

import {
  selectFavouriteWorkoutIds,
  mapIsFavouriteWorkouts,
} from 'logic/favourite';

import {
  updateFilters,
  fetchFiltersWorkouts,
  selectSortByWorkouts,
  selectFiltersWorkoutsChecked,
  selectFiltersWorkoutsGrouped,
  toggleFiltersIsActive,
} from 'logic/filters';

import {
  resetSearch,
  searchWorkouts,
  selectSearchPagination,
  selectSearchParams,
  selectSearchResults,
} from 'logic/search';

export const WorkoutsExpress = {
  template: `
    <ui-view>
      <div class="py-3 py-md-4 bg-gray-100">
        <div class="container">
          <div class="row">
            <div class="col-md-3 pt-md-2">
              <nav-mobile-sidebar
                heading="Filter"
                is-active="$ctrl.filtersIsActive"
                on-click="$ctrl.toggleFiltersIsActive()">
                <search-form class="d-none d-md-block mb-2"
                  placeholder="find workouts"
                  query="$ctrl.params.q"
                  on-submit="$ctrl.onUpdateParam('q', query)">
                </search-form>
                <search-filter-workouts
                  filters="$ctrl.filters"
                  on-click="$ctrl.onUpdateFilter(item, type, key, list)">
                </search-filter-workouts>
              </nav-mobile-sidebar>
            </div>
            <div class="col-md-9">
              <div class="mobile-filter-row row d-flex d-md-none py-2 px-3 bg-white">
                <button class="btn btn-link p-0 d-inline-flex"
                  ng-click="$ctrl.toggleFiltersIsActive()">
                  <i class="fa fa-sliders"></i>
                  <span class="h6 text-green-dark mb-0">Filter</span>
                </button>
                <search-form
                  class="d-inline-flex ml-auto"
                  placeholder="find workouts"
                  query="$ctrl.params.q"
                  on-submit="$ctrl.onUpdateParam('q', query)">
                </search-form>
              </div>
              <search-filter-results
                query="$ctrl.search.params.q"
                filters="$ctrl.checkedFilters"
                on-clear-all="$ctrl.onClearAll()"
                on-update-param="$ctrl.onUpdateParam(key, value)"
                on-update-filter="$ctrl.onUpdateFilter(item, type, key)">
              </search-filter-results>
              <search-results
                on-update-param="$ctrl.onUpdateParam(key, value)"
                order="$ctrl.sortBy"
                pagination="$ctrl.pagination"
                type="workouts">
                <div class="row">
                  <div class="col-sm-6 col-lg-4 pb-3"
                    ng-repeat="item in $ctrl.results track by $index">
                    <card-workout
                      workout="item"
                      member="$ctrl.member"
                      on-click="$ctrl.onClick(item)">
                    </card-workout>
                  </div>
                </div>
              </search-results>
            </div>
          </div>
        </div>
      </div>
    </ui-view>`,

  controller($ngRedux) {
    'ngInject';

    const EMPTY_PARAMS = {
      filters: undefined,
      level: undefined,
      order: undefined,
      page: undefined,
      q: undefined,
      serves: undefined,
    };

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.unsubscribe = connect(this);

        const { router, filters } = $ngRedux.getState();
        const { currentParams } = router;

        // Search for workouts using the current route params.
        this.searchWorkouts(currentParams);

        // Fetch the filters
        if (!filters.workouts.length) {
          this.fetchFiltersWorkouts();
        }

        // Hide mobile sidebar
        this.showMobileSidebar = false;
      },

      $onDestroy() {
        this.unsubscribe();
      },

      onClearAll() {
        this.stateGo('workouts.express', EMPTY_PARAMS);
      },

      onClick({ id, exercisePlanId, name }) {
        if (this.hasAccess) {
          this.stateGo('workouts.express.detail', {
            ...EMPTY_PARAMS,
            id,
            exercisePlanId,
          });

          anchorStorage.set($ngRedux.getState(), name);
        }
      },

      onUpdateFilter(item, type, key, list = []) {
        this.onUpdateParam(
          key,
          updateFilters(item.id, type, this.params[key], list)
        );
      },

      onUpdateParam(key, value = '') {
        const page =
          value !== this.params[key] || key === 'q'
            ? undefined
            : this.params.page;

        this.stateGo('workouts.express', {
          ...this.params,
          page,
          [key]: value,
        });
      },

      mapState({ favourite, filters, member, router, search }) {
        const { order } = router.currentParams;
        const filterParams = router.currentParams.filters;

        return {
          search,
          member: selectMember(member),
          hasAccess: selectHasWorkoutSubscription(member),

          // Search
          filters: selectFiltersWorkoutsGrouped(filters, filterParams),
          filtersIsActive: filters.isActive,
          checkedFilters: selectFiltersWorkoutsChecked(filters, filterParams),
          sortBy: selectSortByWorkouts(filters, order),
          pagination: selectSearchPagination(search),
          params: selectSearchParams(search),
          results: mapIsFavouriteWorkouts(
            selectSearchResults(search),
            selectFavouriteWorkoutIds(favourite)
          ),
        };
      },

      mapDispatch() {
        return {
          fetchFiltersWorkouts,
          resetSearch,
          searchWorkouts,
          stateGo,
          toggleFiltersIsActive,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Workouts/Express.js